import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

let nextId = 0;

export const InkSplash = () => {
  const [splashes, setSplashes] = useState([]);

  useEffect(() => {
    const onClick = (e) => {
      const target = e.target.closest("button, a, [role='button']");
      if (!target) return;
      const id = ++nextId;
      setSplashes((s) => [...s, { id, x: e.clientX, y: e.clientY }]);
      setTimeout(() => {
        setSplashes((s) => s.filter((sp) => sp.id !== id));
      }, 950);
    };
    window.addEventListener("click", onClick);
    return () => window.removeEventListener("click", onClick);
  }, []);

  return (
    <div className="fixed inset-0 z-[95] pointer-events-none overflow-hidden" aria-hidden="true" data-testid="ink-splash-layer">
      <AnimatePresence>
        {splashes.map((sp) => (
          <motion.span
            key={sp.id}
            initial={{ scale: 0.15, opacity: 0.9 }}
            animate={{ scale: 1, opacity: 0 }}
            transition={{ duration: 0.85, ease: "easeOut" }}
            className="fixed -translate-x-1/2 -translate-y-1/2"
            style={{
              left: sp.x,
              top: sp.y,
              width: 96,
              height: 90,
              borderRadius: "46% 54% 52% 48% / 56% 48% 52% 44%",
              background:
                "radial-gradient(ellipse at 42% 40%, rgba(20,20,20,0.92), rgba(20,20,20,0.55) 48%, rgba(20,20,20,0) 72%)",
            }}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};
